module.exports = "<div class=\"kt-login__body\">\r\n\t<div class=\"kt-login__form\">\r\n\t\t<kt-auth-notice></kt-auth-notice>\r\n\t</div>\r\n</div>\r\n\r\n"